import { RcFile, UploadFile } from 'antd/lib/upload';

export const getThumbnail = ({
  file,
  url,
  fileType,
  width,
  height,
}: {
  file?: RcFile;
  url?: string;
  fileType: 'image' | 'video';
  width: number;
  height: number;
}): Promise<string> => {
  return new Promise((resolve, reject) => {
    try {
      const fileUrl = file ? URL.createObjectURL(file) : url || '';
      if (fileType === 'image') {
        resolve(fileUrl);
      } else {
        const video = document.createElement('video');
        video.src = fileUrl;
        video.muted = true;
        video.autoplay = true;
        video.crossOrigin = 'anonymous';

        video.onloadeddata = () => {
          video.currentTime = 0.1;
          video.onseeked = () => {
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);
            const thumbUrl = canvas.toDataURL('image/png');
            URL.revokeObjectURL(video.src);
            resolve(thumbUrl);
          };
        };
      }
    } catch (e) {
      reject(e);
    }
  });
};

export const isVideoFile = (file: File | UploadFile) =>
  file.type?.includes('video');

export const isPdfFile = (file: File | UploadFile) => {
  return (
    file.type?.includes('pdf') ||
    // @ts-ignore
    file.cos_url?.endsWith('.pdf') ||
    // @ts-ignore
    file.url?.endsWith('.pdf')
  );
};
